// To save some bandwidth over the wire, a lot of properties have shortened names, this function unpacks these
export default function (courses, categories, schools) {
    const schoolmap = {};

    schools.map((obj, index) => {
        schoolmap[obj.id] = obj;
    });

    courses.map((obj, index) => {
        if (obj.schoolname) {
            return;
        }
        if (obj.i) {
            obj.courseimage = '/site/img/thumb/' + obj.i.substring(0,1) + '/' +  obj.i.substring(1,2) + '/' + obj.i;
            obj.courseimage += '_480_320.webp';
            delete obj.i;
        }
        if (schoolmap[obj.a]) {
            obj.county = schoolmap[obj.a].county;
            obj.region = schoolmap[obj.a].r + '';
            obj.schoolname = schoolmap[obj.a].schoolname;
            obj.christian = schoolmap[obj.a].christian;
            obj.k = obj.schoolname.toLowerCase() + " " + obj.k;
            delete obj.a;
        }
        obj.coursetype = obj.t;
        delete obj.t;

        obj.coursetypes = obj.coursetype + '-' + obj.y;

        obj.coursename = obj.cn;
        delete obj.cn;
        obj.price = obj.p + '';
        delete obj.p;
        obj.status = obj.s;
        delete obj.s;
        if (obj.r !== undefined) {
            obj.restplass = obj.r;
            delete obj.r;
        }
        else {
            obj.restplass = 0;
        }
        obj.lt = obj.lt + '';
        obj.index = index;
    });
}
